import * as React from "react";
import cx from "classnames";
import style from "./Trusted.css";
import { Shape } from "components/Shape";

import TheGraph from "./img/the-graph.inline.svg";
import OutlierVentures from "./img/outlier-ventures.inline.svg";
import WuVienna from "./img/wu-vienna.inline.svg";
import Giveth from "./img/giveth.inline.svg";
import Interchain from "./img/interchain.inline.svg";
import Curve from "./img/curve-labs.inline.svg";
import Delphia from "./img/delphia.inline.svg";
import Fairmint from "./img/fairmint.inline.svg";
import Metagov from "./img/metagov.inline.svg";
import Protocol from "./img/protocol-labs.inline.svg";
import Reflexer from "./img/reflexer.inline.svg";
import Hedera from "./img/hedera.inline.svg";
import Holo from "./img/holo.inline.svg";
import TokenEngineering from "./img/te.inline.svg";
import NumFocus from "./img/numfocus.inline.svg";

const Item = ({ className, link, title, children }) => (
  <li className={className}>
    <a
      className={style.link}
      href={link}
      title={title}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  </li>
);

export const Trusted = () => (
  <section className={style.root}>
    <Shape className={style.shape1} />
    <Shape className={style.shape2} />

    <div className={cx(style.content)}>
      <div className="container">
        <h2 className={cx(style.header, "wow", "fadeInUp")}>
          Clients and Collaborators
        </h2>
        <ul className={style.list}>
          <Item className={style.item} link="https://www.wu.ac.at/en" title="Wu Vienna">
            <WuVienna />
          </Item>

          <Item className={style.item} link="https://outlierventures.io/" title="Outlier Ventures">
            <OutlierVentures />
          </Item>

          <Item className={style.item} link="https://thegraph.com/" title="TheGraph">
            <TheGraph />
          </Item>

          <Item className={style.item} link="https://interchain.io/" title="Interchain">
            <Interchain />
          </Item>

          <Item className={style.item} link="https://giveth.io/" title="Giveth.io">
            <Giveth />
          </Item>

          <Item className={style.item} link="https://delphia.com/" title="Delphia">
            <Delphia />
          </Item>

          <Item className={style.item} link="https://www.fairmint.co/" title="Fairmint">
            <Fairmint />
          </Item>

          <Item className={style.item} link="https://hedera.com/" title="Hedera">
            <Hedera />
          </Item>

          <Item className={style.item} link="https://metagov.org/" title="MetaGov">
            <Metagov />
          </Item>

          <Item className={style.item} link="https://protocol.ai/" title="Protocol Labs">
            <Protocol />
          </Item>

          <Item className={style.item} link="https://www.curvelabs.eu/" title="Curve Labs">
            <Curve />
          </Item>

          <Item className={style.item} link="https://reflexer.finance/" title="Reflexer Labs">
            <Reflexer />
          </Item> 

          <Item className={style.item} link="https://www.holochain.org/" title="Holo">
            <Holo />
          </Item> 
          <Item className={style.item} link="https://numfocus.org/" title="NumFocus">
            <NumFocus />
          </Item> 
          <Item className={style.item} link="https://tokenengineeringcommunity.github.io/website/docs/academy-welcome/" title="Token Engineering">
            <TokenEngineering />
          </Item> 

        </ul>
      </div>
    </div>
  </section>
);
